module.exports = "/images/vendor/vue-paycard/src/2.jpg?9d227265f94d69b9dd9a64de36947eaa";